import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { TaskSelectButton } from '../../../core/models/task-select-button.model';
import { NgClass, NgIf, NgStyle } from '@angular/common';
import { THEMES } from '../../../core/models/theme.model';
import { FormatStringPipe } from '../../../core/pipes/format-string.pipe';

@Component({
  selector: 'wf-task-select-button',
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    NgStyle,
    FormatStringPipe
  ],
  templateUrl: './task-select-button.component.html',
  styleUrl: './task-select-button.component.css'
})
export class TaskSelectButtonComponent implements OnInit {
  @Input()
  position: number = 1;

  @Input()
  idx: number = 1;

  @Input()
  taskSelect: TaskSelectButton | null = null;

  @Input()
  initializing: boolean = true;

  @Input()
  compareScores: boolean = false;

  @Input()
  alternating: boolean = false;

  @Input()
  isPreDiagnosticStudent: boolean = false;

  @Output()
  onTaskSelectClick = new EventEmitter<number>();

  @Output()
  onTaskSelectTouchStart = new EventEmitter<{ position: number, idx: number }>();

  @Output()
  onTaskSelectTouchEnd = new EventEmitter<{ position: number, idx: number, taskIdx: number, $event: TouchEvent }>();

  @Output()
  onTaskMouseOver = new EventEmitter<{ position: number, idx: number }>();

  @Output()
  onTaskMouseLeave = new EventEmitter<{ position: number, idx: number }>();

  themes = THEMES;
  scoreBoxes: {
    id: number,
    score: number,
    background: string,
    icon: string,
    progressed: boolean,
    completed: boolean,
    started: boolean,
    wordListType: number,
  }[] = [] ;
  wrapperGrids: string = '';

  ngOnInit(): void {
    const completions = this.taskSelect!.completions ;
    const subtasks = this.taskSelect!.subtasks ;
    const suffixes = ['a', 'b', 'c', 'd'] ;
    const basePath = `/assets/images/taskSelect/${this.taskSelect!.theme === THEMES.elementary ? '' : 'theme2/'}scoreboxes/` ;
    let completionIdxs: number[] = [] ;

    if (this.taskSelect!.showPassageTitle)
    {
      // For passage tasks, we want to show the subtasks
      for (let idx = 0; idx < subtasks.length; idx++) {
        const { type, completed, progressed, started } = subtasks[idx];

        this.scoreBoxes.push({
          id: idx,
          score: 0,
          icon: `/assets/images/destination/iconPassageTask_${type}.svg`,
          background: basePath,
          progressed,
          completed,
          started,
          wordListType: 0,
        });
      }
    }
    else
    {
      // For other tasks, we show the completions
      for (let idx = 0; idx < completions.length; idx++) {
        const { score, completed, progressed, started, wordListType } = completions[idx];

        this.scoreBoxes.push({
          id: idx,
          score,
          icon: '',
          background: basePath,
          progressed,
          completed: this.taskSelect!.completed,
          started,
          wordListType,
        });

        if (completed) completionIdxs.push(idx) ;
      }

      if (this.scoreBoxes.length && !this.taskSelect!.completed)
      {
        this.scoreBoxes.push({
          id: this.scoreBoxes.length,
          score: 0,
          icon: '',
          background: basePath,
          progressed: false,
          completed: false,
          started: false,
          wordListType: 0,
        }) ;
      }
    }

    // This should not be necessary, but make sure we only have 4 max scoreboxes
    let completedIdx = completionIdxs.length > 1 ? completionIdxs[completionIdxs.length - 2] + 1 : 0 ;
    this.scoreBoxes = this.scoreBoxes.slice(completedIdx, completedIdx + 4) ;

    // Now that we have our final set, determine our backgrounds
    for (let idx = 0 ; idx < this.scoreBoxes.length ; idx++)
    {
      const taskCompletedBg = this.scoreBoxes[idx].completed ? 'gold' : 'default' ;
      const progressedBg = this.scoreBoxes[idx].progressed ? '_star' : '';
      const boxesStr = this.scoreBoxes.length > 1 ? `${this.scoreBoxes.length}${suffixes[idx] ?? 'a'}` : `${this.scoreBoxes.length}`;

      if (this.taskSelect!.showPassageTitle)
      {
        this.scoreBoxes[idx].background += `passageScoreBox-${boxesStr}-${taskCompletedBg}${progressedBg}.svg` ;
      }
      else
      {
        this.scoreBoxes[idx].background += `taskScoreBox-${boxesStr}-${taskCompletedBg}${progressedBg}.svg` ;
      }
    }

    this.wrapperGrids = `grids-${this.scoreBoxes.length}` ;
  }

  onTaskClick() {
    this.onTaskSelectClick.emit(this.taskSelect!.index);
  }

  onTouchStart() {
    this.onTaskSelectTouchStart.emit({ position: this.position, idx: this.idx }) ;
  }

  onTouchEnd($event: TouchEvent) {
    this.onTaskSelectTouchEnd.emit({ position: this.position, idx: this.idx, taskIdx: this.taskSelect!.index, $event });
  }

  onMouseOver() {
    this.onTaskMouseOver.emit({ position: this.position, idx: this.idx });
  }

  onMouseLeave() {
    this.onTaskMouseLeave.emit({ position: this.position, idx: this.idx });
  }
}
